import { SxProps, Theme } from '@mui/material/styles';

export const facetNavigationAccordionSummarySX: SxProps<Theme> = {
	px: '10px',
	minHeight: 'initial',

	'&[role="button"]:hover': {
		cursor: { md: 'pointer' },
	},
	'& .MuiAccordionSummary-content': {
		p: 0,
	},
	'& .MuiAccordionSummary-expandIconWrapper': {
		p: '0 !important',
		color: 'theme.palette.text.primary',
		opacity: 1,
	},
};
